/**
 * Global cache for leaderboard token prices.
 * Persists across navigation so returning from token analysis shows cached prices
 * instead of loading state.
 */

export interface CachedPriceEntry {
  price: number | null;
  change: number | null;
}

const cache = new Map<string, CachedPriceEntry>();

/** Max entries to keep (LRU-style: oldest evicted when over limit) */
const MAX_ENTRIES = 60;

export function getCachedPrice(alertId: string): CachedPriceEntry | undefined {
  return cache.get(alertId);
}

export function setCachedPrice(
  alertId: string,
  entry: CachedPriceEntry
): void {
  if (cache.size >= MAX_ENTRIES && !cache.has(alertId)) {
    const firstKey = cache.keys().next().value;
    if (firstKey) cache.delete(firstKey);
  }
  cache.set(alertId, entry);
}

export function getCachedPricesForAlerts(
  alertIds: string[]
): Map<string, CachedPriceEntry> {
  const result = new Map<string, CachedPriceEntry>();
  for (const id of alertIds) {
    const entry = cache.get(id);
    if (entry) result.set(id, entry);
  }
  return result;
}
